var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVolumeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 8,
    viewBox: "0 0 60 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1564_80497)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.769531,
    y: 2.87805,
    width: 75.155,
    height: 1.61426,
    rx: 0.807128,
    fill: "#C8CFD9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.769531,
    y: 2.99341,
    width: 35.5136,
    height: 1.69099,
    rx: 0.807128,
    fill: "#4C76E0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.4766,
    cy: 3.68518,
    r: 3.22851,
    fill: "#4C76E0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1564_80497"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58.6209,
    height: 6.76395,
    fill: "white",
    transform: "translate(0.769531 0.456665)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeIcon);
export default __webpack_public_path__ + "static/media/volumeIcon.ba826b347a6e55409ac56afabfecc6c6.svg";
export { ForwardRef as ReactComponent };